import { gql } from "@/Common/context/subscriptions/Subscriptions";

export const ON_UPDATE_SYSTEM_SETTINGS_SUBSCRIPTION = gql`
	subscription onUpdateSystemSettings($locationId: String) {
		onUpdateSystemSettings(locationId: $locationId) {
			_id
			locationId
			technicalContacts
			maxAllowableBorrowedPTO
			minimumWage
			drawModalities {
				drawModality
				position
			}
			workingDays {
				workingDays
				position
			}
			mappedPositions {
				systemPosition
				isDepartmental
				overtime
			}
			commissionSupportTeam {
				_id
				fullName
				position
				employeeId
				profilePicture
				communications {
					communicationType
					usage
					value
				}
			}
			washoutReviewers {
				lastModifiedBy {
					_id
					employeeId
					communications {
						acceptsTxt
						communicationType
						usage
						value
					}
					fullName
					position
				}
				lastModifiedOn
				position
				reviewerId {
					_id
					communications {
						acceptsTxt
						communicationType
						usage
						value
					}
					employeeId
					fullName
					position
				}
				isDirectSupervisor
			}
			commissionCyclesPerMonth {
				lastModifiedOn
				value
				lastModifiedBy {
					_id
					communications {
						acceptsTxt
						communicationType
						usage
						value
					}
					employeeId
					fullName
					position
				}
			}
			isGlobalRanking
			chargebackLimits {
				lastModifiedOn
				position
				value
				lastModifiedBy {
					_id
					communications {
						acceptsTxt
						usage
						value
						communicationType
					}
					employeeId
					fullName
					position
				}
			}
			chargebackTypes {
				position
				grossChargebackTypes {
					chargebackCode
					productType
				}
				deductionsChargebackTypes {
					chargebackCode
					earningPayItem
					deductionPayItem
				}
			}
			chargebackAccountReferences {
				position
				chargebackTypes {
					label
					description
					repairOrderRoute
					accountNumbers
				}
			}
			advisorsRankingConfiguration {
				isRankingRO
				category
			}
			citMaxGraphValues {
				maxUnfundedDollars
				maxUnfundedContracts
			}
			citMinimumBalance
			citMaxScheduleDays
			citScheduledAccountNumbers {
				label
				values
			}
			citEmailDistribution {
				toIndividuals {
					_id
					employee {
						_id
						employeeId
						fullName
						jobTitle
					}
				}
				toNonEmployee
				accountNumbers {
					sourceAccount
					destinationAccount
					sourceLabelId
				}
			}
			crossStoreEmailDistribution {
				toIndividuals {
					_id
					employeeId
				}
				toNonEmployee
				accountMappings {
					sourceGlAccount
					destinationStore
					destinationGlAccount
					destinationSourceLabel {
						label
						value
					}
					destinationControlType {
						label
						value
						identifier
					}
				}
			}
			defaultPayPlans {
				position
				defaultPayPlan
				newVehiclePayPlan
				preOwnedVehiclePayPlan
			}
			citMaxGraphValues {
				maxUnfundedDollars
				maxUnfundedContracts
			}
			citGraphWidth
			citCommissionPayout {
				isPayFundedDealsOnly
				toPositions
			}
			pvrMaxGraphValues {
				maxNewVehiclesPVR
				maxPreOwnedVehiclesPVR
				maxFinancePVR
				maxTotalPVR
			}
			callActivityPerformance {
				maxAllowableTurnaroundTime {
					hours
					minutes
				}
				minimumTalkDuration {
					minutes
					seconds
				}
				minimumRingDuration {
					seconds
				}
				minimumTotalDuration {
					minutes
					seconds
				}
				enableTalkTime
				enableRingTime
				enableTotalTime
			}
			salesLogs {
				franchises
				exportFormat
				dailyDistributions
				toPositions
				toIndividuals {
					_id
					employee {
						communications {
							value
							usage
							communicationType
							acceptsTxt
						}
						employeeId
						fullName
						_id
					}
				}
				toEmails
			}
			salesLogInitialDataFilter {
				name
				filterOptions {
					name
					included
					enabled
					disabled
				}
			}
			blacklistPhoneNumbers {
				_id
				phoneNumber
				createdAt
			}
			appendingConfiguration {
				_id
				position
				data {
					_id
					reference
					oems {
						_id
						configuration {
							_id
							franchise
							isCombined
							groups {
								franchiseName
							}
							data {
								_id
								accountDescription
								fsAccount
								glAccount {
									glAccount
									accountType
								}
								groupInfo {
									group
									subGroup
								}
								arithmeticExpression {
									operation
									value
								}
								properties {
									isChargeback
								}
							}
						}
						oemReference
						dealerCodeFS
						fsVersion
						version
					}
				}
			}
			payplanTermConditions {
				position
				inEditionBy {
					_id
					fullName
				}
				termConditions {
					_id
					componentName
					sectionTitle
					content
					createdAt
					createdBy
					updatedAt
					updatedBy
				}
			}
		}
	}
`;
